module.exports = __webpack_public_path__ + "img/2.c414fe7c.jpeg";